import React from "react";
import { Star } from "lucide-react";
import { DreamEditButton } from "@/components/ascend/DreamEditModal";
import DailyNorthStarQuote from "@/components/ascend/DailyNorthStarQuote";

export default function NorthStarBanner({ northStar, targetUni, targetGrades, onEdit }) {
  return (
    <section
      className="north-star-banner group relative px-6 sm:px-12 py-10 sm:py-14 fade-up"
      data-testid="north-star-banner"
    >
      {onEdit && <DreamEditButton onClick={onEdit} />}
      <div className="flex items-center gap-2 mb-4">
        <Star size={16} strokeWidth={1.5} style={{ color: "var(--primary)" }} />
        <span className="eyebrow">your north star</span>
      </div>
      <h1
        className="font-display text-3xl sm:text-5xl lg:text-6xl leading-[1.1] max-w-3xl"
        style={{ color: "var(--text)" }}
        data-testid="north-star-text"
      >
        <span className="italic">"</span>
        {northStar || "Add your dream — it will live here to remind you."}
        <span className="italic">"</span>
      </h1>

      <DailyNorthStarQuote />

      {(targetUni || targetGrades) && (
        <div className="mt-6 flex flex-wrap gap-2">
          {targetUni && (
            <span
              className="text-xs sm:text-sm font-medium px-3 py-1 rounded-full"
              style={{ background: "var(--surface)", color: "var(--accent)", border: "1px solid var(--border)" }}
              data-testid="target-uni-chip"
            >
              aiming for {targetUni}
            </span>
          )}
          {targetGrades && (
            <span
              className="text-xs sm:text-sm font-medium px-3 py-1 rounded-full"
              style={{ background: "var(--surface)", color: "var(--accent)", border: "1px solid var(--border)" }}
              data-testid="target-grades-chip"
            >
              {targetGrades}
            </span>
          )}
        </div>
      )}
    </section>
  );
}
